import { render, staticRenderFns } from "./MessagingDashboard.vue?vue&type=template&id=19e34906&"
import script from "./MessagingDashboard.vue?vue&type=script&lang=js&"
export * from "./MessagingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports